// Practice round page: clicking a leaderboard row opens that golfer's
// scorecard in the modal. Every scorecard is already on the page, in a
// <template data-practice-scorecard="id">, so nothing is fetched. Separate from
// team_rounds_modal.js (its own modal id and data attributes), so the
// tournament's scorecard modals are untouched. Turbolinks, not Turbo.

const PracticeScorecard = {
  init() {
    const modal = document.getElementById('practiceScorecardModal');
    if (!modal || modal.dataset.practiceReady === 'true') return;
    modal.dataset.practiceReady = 'true';

    document.querySelectorAll('[data-practice-round-id]').forEach((row) => {
      row.addEventListener('click', () => PracticeScorecard.open(modal, row.dataset.practiceRoundId));
    });

    modal.addEventListener('click', (event) => {
      // The backdrop (outside the dialog) or the close button closes it.
      if (event.target === modal || event.target.closest('[data-practice-scorecard-close]')) {
        PracticeScorecard.close(modal);
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.style.display !== 'none') PracticeScorecard.close(modal);
    });
  },

  open(modal, id) {
    const template = document.querySelector(`template[data-practice-scorecard="${id}"]`);
    if (!template) return;

    const body = modal.querySelector('.modal-body');
    body.innerHTML = '';
    body.appendChild(template.content.cloneNode(true));
    modal.style.display = 'flex';
    document.body.classList.add('overflow-hidden');
    // Lets scorecard_sticky.js measure the locked top block.
    document.dispatchEvent(new CustomEvent('faso:modal-loaded', { detail: modal }));
  },

  close(modal) {
    modal.style.display = 'none';
    modal.querySelector('.modal-body').innerHTML = '';
    document.body.classList.remove('overflow-hidden');
  }
};

document.addEventListener('turbolinks:load', PracticeScorecard.init);

// Turbolinks caches the page as it is: close the modal first, and clear the
// ready flag, since the restored copy has none of the listeners.
document.addEventListener('turbolinks:before-cache', () => {
  const modal = document.getElementById('practiceScorecardModal');
  if (!modal) return;
  PracticeScorecard.close(modal);
  delete modal.dataset.practiceReady;
});

export default PracticeScorecard;
